import { usePageFocusState } from "ui/utils/FocusHook";
import { usePortalContext } from "./PortalProvider";

interface Props {
  hostName: string;
  identifier: string;
  children: React.ReactNode;
}

export function Portal({ hostName, identifier, children }: Props) {
  const { setPortalHost, clearPortalHost } = usePortalContext();

  usePageFocusState((focused) => {
    if (focused) {
      setPortalHost(hostName, identifier, children);
    } else {
      clearPortalHost(hostName, identifier);
    }
  }, []);

  return null;
}
